import { jsx as s, jsxs as T, Fragment as _ } from "../../_virtual/jsx-runtime.mjs";
import * as l from "react";
import { active as P, reoTabsWrapper as H, sizeMap as U, showLine as E, canScroll as q, scrollBtn as J, btnShadow as Q, activeColor as Y, scrollIcon as Z, tabsContainer as p, reoTabs as ee, sizeStyle as te, reoTabsBarAnimated as le, reoTab as ne } from "./css/ReoTabs.mjs";
import i from "../../depend/classnames/index.mjs";
import { EThemeTemplate as ae } from "../../common/type.mjs";
import { suffixPx as ce } from "../../utils/suffixPx.mjs";
import { getValByDef as m } from "../../utils/getValByDef.mjs";
import { e as oe } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import { defaultReoTabsProps as w, tabPositionConfig as se, TOLERANCE as ie } from "./const.mjs";
import re from "../ReoIcon/ReoIcon.mjs";
import { useTheme as ue } from "../../hook/useTheme.mjs";
const me = (e) => {
  const f = l.useCallback(() => {
    var c;
    (c = e.onMouseDown) == null || c.call(e, e.value);
  }, [e]);
  return /* @__PURE__ */ s(
    "div",
    {
      onMouseDown: f,
      className: i(e.className, ne, e.active ? P : null),
      style: e.style,
      children: e.label
    }
  );
}, fe = (e) => {
  var D, $;
  const f = ue({ theme: e.theme, template: ae.TABS }), c = l.useMemo(() => {
    var t;
    return m((t = e.optionName) == null ? void 0 : t.value, "value");
  }, [(D = e.optionName) == null ? void 0 : D.value]), z = l.useMemo(() => {
    var t;
    return m((t = e.optionName) == null ? void 0 : t.label, "label");
  }, [($ = e.optionName) == null ? void 0 : $.label]), N = l.useMemo(() => m(e.size, w.size), [e.size]), k = l.useMemo(
    () => se[m(e.tabPosition, w.tabPosition)],
    [e.tabPosition]
  ), x = l.useMemo(
    () => e != null && e.tabBarGutter ? {
      "--tab-bar-gutter": `${e.tabBarGutter}px`,
      "--padding": `${e.tabBarGutter}px 0 ${e.tabBarGutter}px ${e.tabBarGutter}px`
    } : {},
    [e.tabBarGutter]
  ), h = l.useMemo(() => m(
    e.scroll,
    w.scroll
  ), [e.scroll]), G = l.useMemo(
    () => ({
      ...x,
      "--color": e.color,
      "--hover-color": e.hoverColor,
      "--active-color": e.activeColor,
      "--width": e.width ? ce(e.width) : "fit-content",
      ...e.style
    }),
    [e.activeColor, e.color, e.hoverColor, e.style, e.width, x]
  ), [W, y] = l.useState({
    width: "",
    left: ""
  }), a = l.useRef(null), A = oe(a);
  l.useEffect(() => {
    var t;
    if (a.current) {
      const n = (t = a.current) == null ? void 0 : t.getElementsByClassName(`${P}`)[0];
      n && (e.tabPosition === "Vertical" ? y({
        height: `${n.scrollHeight}px`,
        top: `${n.offsetTop}px`
      }) : y({
        width: `${n.scrollWidth}px`,
        left: `${n.offsetLeft}px`
      }));
    }
  }, [A, e.active, e.tabPosition, a]);
  const X = l.useMemo(
    () => {
      var t, n;
      return ((n = (t = e.options.filter((C) => C[c] === e.active)) == null ? void 0 : t[0]) == null ? void 0 : n.content) ?? null;
    },
    [e.active, e.options, c]
  ), M = l.useMemo(
    () => m(e.showLine, w.showLine),
    [e.showLine]
  ), I = l.useMemo(() => i(
    f,
    H,
    U[N].font,
    k.css,
    M ? E : null,
    h ? q : null
  ), [f, N, k.css, M, h]), b = l.useRef(null), L = l.useRef(""), V = l.useCallback((t) => {
    b.current = Date.now(), L.current = t;
  }, []), g = l.useRef(!1), d = l.useRef(0), j = l.useCallback((t) => {
    g.current = !0, d.current = t.pageX;
  }, []), [r, F] = l.useState("none"), o = l.useCallback(() => {
    const t = a.current;
    if (!t)
      return;
    const n = (t.scrollWidth ?? 0) - (t.clientWidth ?? 0), C = t.scrollLeft ?? 0;
    let B = "none";
    n > 0 && (C === 0 ? B = "start" : Math.abs(n - C) <= ie ? B = "end" : B = "middle"), F(B);
  }, []), S = l.useCallback(() => {
    var t;
    b.current && Date.now() - b.current < 200 && ((t = e.onChange) == null || t.call(e, L.current), b.current = null, L.current = ""), g.current = !1, d.current = 0;
  }, [e]), R = l.useCallback((t) => {
    if (g.current && a.current) {
      if (d.current) {
        const n = d.current - t.pageX;
        a.current.scrollLeft += n;
      }
      d.current = t.pageX, o();
    }
  }, [o]);
  l.useEffect(() => (document.addEventListener("mouseup", S), document.addEventListener("mousemove", R), () => {
    document.removeEventListener("mouseup", S), document.removeEventListener("mousemove", R);
  }), [R, S]);
  const u = l.useCallback((t) => {
    a.current && (t === "right" ? a.current.scrollLeft += a.current.clientWidth - 20 : a.current.scrollLeft -= a.current.clientWidth - 20, o());
  }, [o]), v = l.useCallback((t) => {
    const n = () => {
      u(t);
    };
    return h && e.scrollBtn ? /* @__PURE__ */ s(
      "div",
      {
        className: i(
          J[t],
          { [E]: e.showLine },
          { [Q]: e.showButtonShadow },
          t === "right" ? e.scrollRightBtnClassName : e.scrollLeftBtnClassName
        ),
        onClick: n,
        children: /* @__PURE__ */ s(
          re,
          {
            width: 24,
            color: Y,
            hoverColor: "var(--b_6)",
            name: `icon-co_${t}`,
            className: Z
          }
        )
      }
    ) : null;
  }, [
    u,
    e.scrollBtn,
    e.scrollLeftBtnClassName,
    e.scrollRightBtnClassName,
    e.showButtonShadow,
    e.showLine,
    h
  ]), K = l.useMemo(() => {
    var t;
    return r !== "middle" && r !== "start" ? null : ((t = e.scrollRightBtn) == null ? void 0 : t.call(e, () => {
      u("right");
    })) ?? v("right");
  }, [u, e, v, r]), O = l.useMemo(() => {
    var t;
    return r !== "middle" && r !== "end" ? null : ((t = e.scrollLeftBtn) == null ? void 0 : t.call(e, () => {
      u("left");
    })) ?? v("left");
  }, [u, e, v, r]);
  return l.useEffect(() => {
    const t = a.current;
    if (!t)
      return;
    const n = new ResizeObserver(o);
    return n.observe(t), () => {
      n.disconnect();
    };
  }, [o]), /* @__PURE__ */ T(_, { children: [
    /* @__PURE__ */ T(
      "div",
      {
        className: i(f, p, e.className),
        style: G,
        children: [
          O,
          /* @__PURE__ */ s(
            "div",
            {
              className: i(I, e.scrollContainerClassName ?? ""),
              ref: a,
              onMouseDown: j,
              onScroll: o,
              children: /* @__PURE__ */ T(
                "div",
                {
                  className: i(ee, e.tabsClassName, te[N]),
                  children: [
                    e.options.map((t) => /* @__PURE__ */ s(
                      l.Fragment,
                      {
                        children: /* @__PURE__ */ s(
                          me,
                          {
                            className: e.tabBarClassName,
                            style: e.tabBarStyle,
                            onMouseDown: V,
                            active: t[c] === e.active,
                            value: t[c],
                            label: t[z]
                          }
                        )
                      },
                      t[c]
                    )),
                    M ? /* @__PURE__ */ s(
                      "div",
                      {
                        className: i(le, e.activeLineClassName ?? ""),
                        style: W
                      }
                    ) : null
                  ]
                }
              )
            }
          ),
          K
        ]
      }
    ),
    X
  ] });
};
fe.displayName = "ReoTabs";
export {
  fe as default
};
//# sourceMappingURL=ReoTabs.mjs.map
